import React, { Fragment, useState } from "react";
import { Input } from "reactstrap";
import { showToast } from "../../../utils/helper";

import { getPortfolioXLS, getPortfolioCSV } from "../../../services/api/accounts";
import pdf from "../../../style/assets/svg/pdf.svg";
import excel from "../../../style/assets/svg/xlsx.svg";
import csv from "../../../style/assets/svg/csv.svg";

import style from "./PortfolioHeader.scss";

export const PortfolioHeader = ({ portfolio, onChangeDate, date }) => {
  const handleChangeDate = (event) => {
    onChangeDate(event.target.value);
  };

  const handleXLS = () => {
    getPortfolioXLS(portfolio).then((r) => {
      try {
        const blob = new Blob([new Uint8Array(r.response.buffer.data)], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Portfolio.xlsx";
        link.click();
      } catch (ex) {
        console.error(ex);
        showToast("Error obteniendo archivo", true);
      }
    });
  };

  const handleCSV = () => {
    getPortfolioCSV(portfolio.position).then((r) => {
      try {
        const blob = new Blob([new Uint8Array(r.response.buffer.data)], {
          type: "application/csv;",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Portfolio_USD.csv";
        link.click();
      } catch (ex) {
        console.error(ex);
        showToast("Error obteniendo archivo", true);
      }
    });
    getPortfolioCSV(portfolio.positionPYG).then((r) => {
      try {
        const blob = new Blob([new Uint8Array(r.response.buffer.data)], {
          type: "application/csv;",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Portfolio_PYG.csv";
        link.click();
      } catch (ex) {
        console.error(ex);
        showToast("There was an error downloading authorizations", true);
      }
    });
  };

  return (
    <Fragment>
      <div className={style.secondRow}>
        <div className={style.date}>
          <div className={style.titleAndInput}>
            <p>Fecha</p>
            <Input
              type="date"
              className={style.input}
              name="fromDate"
              id="fromDate"
              value={date}
              onChange={handleChangeDate}
            />
          </div>
        </div>
        <div className={style.download}>
          <p>Descarga el cierre del mes:</p>
          <img className={style.icon} src={pdf} alt="PDF" onClick={window.print} />
          <img className={style.icon} src={excel} alt="XLSX" onClick={handleXLS} />
          <img className={style.icon} src={csv} alt="CSV" onClick={handleCSV} />
        </div>
      </div>
    </Fragment>
  );
};
